import { constructUrl } from "@pathwright/web/src/modules/utils/urls"

const getDiscussionContext = (discussion) => {
  const context = {
    course: discussion.resource_id,
    class: discussion.cohort_id,
    step: discussion.step_id
  }

  return context
}

export const getDiscussionListHandlers = ({
  canStartDiscussion,
  baseRoute,
  type,
  createTypes,
  updateTypes
}) => {
  let onStartDiscussion = null
  if (canStartDiscussion) {
    onStartDiscussion = ({ onCreateDiscussion }) =>
      window.App.navigate(constructUrl(baseRoute, "new"), {
        onCreateDiscussion,
        type,
        types: createTypes
      })
  }

  const onSelectDiscussion = (
    discussion,
    { view, onUpdateDiscussion, onDeleteDiscussion, viaReplyPrompt = false }
  ) => {
    const state = {
      view,
      onUpdateDiscussion,
      onDeleteDiscussion,
      type,
      types: updateTypes,
      context: getDiscussionContext(discussion)
    }
    const pathname = constructUrl(baseRoute, discussion.id)
    const search = viaReplyPrompt ? "intent=reply" : ""
    window.App.navigate({ pathname, search, state })
  }

  return {
    onStartDiscussion,
    onSelectDiscussion
  }
}
